var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "emojiPickerDialog",
    class: {
      'emoji-picker': true,
      'emoji-picker-h5': !_vm.isPC
    }
  }, [_c('ul', {
    ref: "emojiPickerListRef",
    class: ['emoji-picker-list', !_vm.isPC && 'emoji-picker-h5-list']
  }, _vm._l(_vm.currentEmojiList, function (childrenItem, childrenIndex) {
    return _c('li', {
      key: childrenIndex,
      staticClass: "emoji-picker-list-item",
      on: {
        "click": function ($event) {
          return _vm.select(childrenItem, childrenIndex);
        }
      }
    }, [_c('img', {
      staticClass: "emoji",
      attrs: {
        "src": _vm.BASIC_EMOJI_URL + _vm.BASIC_EMOJI_URL_MAPPING[childrenItem]
      }
    })]);
  }), 0), _c('ul', {
    staticClass: "emoji-picker-tab"
  }, [_vm.isH5 ? _c('li', {
    staticClass: "send-btn",
    on: {
      "click": _vm.sendMessage
    }
  }, [_vm._v(" " + _vm._s(_vm.TUITranslateService.t("发送")) + " ")]) : _vm._e()])]);
}
var staticRenderFns = []

export { render, staticRenderFns }